<template>
    <div>
        <h1 style="font-size: 24px; color: black;">发现页管理</h1>
        <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="showDetails('新增父级')">添加父级</el-button>
        </div>
        <h1>
            <el-table border max-height="550"
                      :data="blocks">
                <el-table-column label="编号" prop="id" align="center"></el-table-column>
                <el-table-column label="名称" prop="name" align="center"></el-table-column>
                <el-table-column label="介绍" prop="notes" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column label="排序" align="center">
                    <template slot-scope="scope">
                        <el-input-number size="small" :min="0" v-model="scope.row.ranking"
                                         @change="updateBlock(scope.row,0)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state === true" class="sub-sub" type="success" @click="updateBlock(scope.row,1)">
                            已启用
                        </el-button>
                        <el-button v-if="scope.row.state === false" class="sub-sub" type="danger" @click="updateBlock(scope.row,1)">
                            已禁用
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="显示规则" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-row v-if="scope.row.showStyle===0 " >{{'全部'}}</el-row>
                        <el-row v-if="scope.row.showStyle===1 " >{{'国内'}}</el-row>
                        <el-row v-if="scope.row.showStyle===2 " >{{'海外'}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑父级',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="子类" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" @click="blockManage(scope.row)">去管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="blockEditForm" :label-width="labelWidth">
                    <el-form-item label="版块名称:">
                        <el-input style="width: 300px" type="text" v-model="blockEditForm.name"></el-input>
                    </el-form-item>

                    <el-form-item label="介绍 :" :label-width="labelWidth">
                        <el-input type="text" v-model="blockEditForm.notes"></el-input>
                    </el-form-item>
                    <el-form-item label="排序 :" :label-width="labelWidth">
                        <el-input-number :min="0" v-model="blockEditForm.ranking"></el-input-number>
                    </el-form-item>
                    <el-form-item label="展示规则 :" :label-width="labelWidth">
                        <el-select v-model="blockEditForm.showStyle" placeholder="请选择">
                            <el-option v-for="type in selections.showStyles"
                                       :key="type.id"
                                       :label="type.name"
                                       :value="type.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态 :" :label-width="labelWidth">
                        <el-radio v-model="blockEditForm.state" :label="false">不显示</el-radio>
                        <el-radio v-model="blockEditForm.state" :label="true">显示</el-radio>
                    </el-form-item>

                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmForm">确 定</el-button>
                        <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>
    </div>
</template>

<script>
    import {
        selections,
        searchBlock,
        saveBlock,
        deleteBlock
    } from "@/http/iosApi";

    export default {
        name: "BlockRule",
        data() {
            return {
                blocks: [],
                labelWidth: '150px',
                dialogVisible: false,
                dialogTitle: '',
                blockEditForm: {},
                selections: {},
                queryData: {},
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods: {
            search() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                this.queryData.type = [1];
                this.queryData.parentId = null;
                searchBlock(this.queryData).then(resp => {
                    this.blocks = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            updateBlock(row,position) {
                this.blockEditForm = {
                    "id": row.id,
                    "name": row.name,
                    "notes": row.notes,
                    "ranking": row.ranking,
                    "showStyle": row.showStyle,
                    "type": row.type,
                    "state": position === 0 ? row.state : !row.state
                };
                this.$confirm('此操作将更改该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    saveBlock(this.blockEditForm).then(resp => {
                        if (resp.data.status === 0) {
                            this.search();
                        }
                    })
                }).catch(() => {
                    this.search();
                });
            },
            showDetails(title, row) {
                selections().then(resp => {
                    this.selections = resp.data.info;
                })
                this.blockEditForm = {
                    "id": 0,
                    "name": '',
                    "notes": '',
                    "ranking": 0,
                    "type": 1,
                    "state": false,
                    "showStyle": 0

                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if (row) {
                    this.blockEditForm = {
                        "id": row.id,
                        "name": row.name,
                        "notes": row.notes,
                        "ranking": row.ranking,
                        "type": row.type,
                        "state": row.state,
                        "showStyle": row.showStyle
                    };
                }
            },
            confirmForm() {
                let _message = '';
                if (this.blockEditForm.name === '') {
                    _message = '请输入应用名称'
                } else if (this.blockEditForm.blockStyle === '') {
                    _message = '请选择类型'
                }
                if (_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveBlock(this.blockEditForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteBlock(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search()
                        }
                    });
                }).catch(() => {
                })
            },
            blockManage(block) {
                this.$store.commit('addBlock', block);
                this.$router.push({path: '/secondBlockRule'});
            }
        },
        created() {
            this.search();
        },

    }
</script>

<style scoped>

</style>